import React from 'react';
import { motion } from 'framer-motion';
import { Hand, Sparkles, Footprints, Droplets, Dumbbell, Heart } from 'lucide-react';
const services = [{
  icon: Hand,
  en: 'Traditional Chinese Massage',
  cn: '中式推拿',
  desc: 'Therapeutic techniques to balance Qi and relieve muscle tension.'
}, {
  icon: Sparkles,
  en: 'Thai Massage',
  cn: '泰式按摩',
  desc: 'Ancient healing system combining acupressure and assisted yoga postures.'
}, {
  icon: Footprints,
  en: 'Foot Reflexology',
  cn: '足部按摩',
  desc: 'Focused pressure on feet to improve health in corresponding body parts.'
}, {
  icon: Droplets,
  en: 'Aromatherapy SPA',
  cn: '精油SPA',
  desc: 'Relaxing massage using essential oils to enhance physical and emotional health.'
}, {
  icon: Dumbbell,
  en: 'Sports Massage',
  cn: '运动按摩',
  desc: 'Targeted therapy for athletes to prevent injuries and improve performance.'
}, {
  icon: Heart,
  en: 'Couples Massage',
  cn: '情侣按摩',
  desc: 'Shared relaxation experience perfect for partners or friends.'
}];
export function ServicesSection() {
  return <section id="services" className="py-24 bg-white relative overflow-hidden" data-id="element-264">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-265">
        <div className="text-center mb-16" data-id="element-266">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-forest mb-4" data-id="element-267">
            Our Services <span className="text-gold font-light" data-id="element-268">服务项目</span>
          </h2>
          <p className="text-stone max-w-2xl mx-auto" data-id="element-269">
            Explore our comprehensive range of professional massage therapies
            designed to restore balance and harmony.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-270">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group p-8 rounded-2xl bg-cream/30 border border-stone/10 hover:bg-cream hover:border-gold/30 hover:shadow-lg hover:shadow-gold/5 transition-all duration-300 cursor-pointer" data-id="element-271">
              <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center mb-6 text-gold group-hover:bg-gold group-hover:text-white transition-colors duration-300 shadow-sm" data-id="element-272">
                <service.icon size={28} strokeWidth={1.5} data-id="element-273" />
              </div>
              <h3 className="text-xl font-serif font-bold text-forest mb-1 group-hover:text-gold-dark transition-colors" data-id="element-274">
                {service.en}
              </h3>
              <h4 className="text-lg font-medium text-stone/60 mb-3 font-serif" data-id="element-275">
                {service.cn}
              </h4>
              <p className="text-stone/80 text-sm leading-relaxed" data-id="element-276">
                {service.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}